import React from 'react';
import { EllipsisIcon } from '../../Icons';
import styles from '../index.module.scss';

export const BreadcrumbEllipsis: React.FC = () => {
  return (
    <span className={styles.ellipsis} aria-hidden='true'>
      <EllipsisIcon />
    </span>
  );
};
